import { cleanUserStore, userStore } from './store'
import { get } from 'svelte/store'
import { API } from './api/api.js'
import { getCookie, setCookie, removeCookie} from 'tiny-cookie'
import { push } from 'svelte-spa-router'

export function checkLastVisited () {
  const lastVisit = getCookie('last-visit')
  console.log('[DEBUG] last-visit', lastVisit)
  if (lastVisit == null || lastVisit === '') {
    return
  }
  removeCookie('last-visit')
  push(lastVisit)
}

export function arrayFilterByRoles (columns, roles) {
  // console.log('[DEBUG] arrayFilterByRoles', roles, columns)
  const cc = []
  for (const c of columns) {
    // console.log('[DEBUG] c.roles', c.roles)
    if (c.roles == null || roles.some(r => c.roles.includes(r))) {
      cc.push(c)
    }
  }
  return [...cc]
}

export function objectFilterByRoles (filters, roles) {
  const ff = {}
  for (const key of Object.keys(filters)) {
    const f = filters[key]
    if (f.roles == null || roles.some(r => f.roles.includes(r))) {
      ff[key] = f
    }
  }
  return {...ff}
}


export const User = function () {
  this.api = new API()
}

User.prototype.checkAuth = async function () {
  if (getCookie('XSRF-TOKEN') === '') {
    cleanUserStore()
    return false
  }
  let localRoles = []
  const {claims} = await this.api.UserInfo()
  if (claims) {
    localRoles = await this.api.UserLocalRoles(claims.preferred_username)
    userStore.update(p => ({
      ...p,
      userInfo: claims,
      roles: [...localRoles, ...(claims?.user_roles || [])],
      username: claims.name
    }))
    return true
  }
  cleanUserStore()

  const user = get(userStore)
  console.log('[DEBUG] userInfo', user.userInfo)
  console.log('[DEBUG] userRoles', user.roles)
  return false
}

User.prototype.login = function () {
  console.log('[DEBUG] login ...', )
  setCookie('last-visit', window.location.hash)
  this.api.Login()
}

User.prototype.logout = function () {
  removeCookie('XSRF-TOKEN')
  removeCookie('auth_token')
  cleanUserStore()
  this.api.Logout()
}

User.prototype.getUsername = function () {
  return get(userStore).username
}

